
export * from './create-edit-window.component'; //Base
export * from './create-edit-action.component';
export * from './create-edit-role.component';
export * from './create-edit-user.component';
export * from './create-edit-permission.component';

export * from './edit-user-password.component';
export * from './edit-role-permissions.component';

export * from './create-edit-authority.component';
export * from './create-edit-person.component';
export * from './create-edit-person-operator.component';
export * from './create-edit-vehicle-type.component';
export * from './create-edit-vehicle-status.component';
export * from './create-edit-deposit.component';
export * from './create-edit-vehicle-entry.component';
export * from './edit-vehicle-inventory.component';
export * from './edit-vehicle-inventory-cost-crane.component';
export * from './create-edit-crane.component';
export * from './create-edit-service-output.component';
export * from './edit-service-inventory.component';
export * from './create-edit-payment-type.component';
export * from './create-edit-service-status.component';
export * from './create-edit-expense-type.component';
export * from './create-edit-expense.component';
export * from './create-edit-customer.component';
export * from './create-edit-payment.component';

export * from './config-window.component'; //Base
export * from './config-date.component';
export * from './config-range-date.component';

export * from './detail-vehicle-images.component'; //Base
export * from './detail-credit-payments.component';
export * from './detail-receipt.component';

export * from './edit-invoice.component';

export * from './cancel-window.component'; //Base
export * from './cancel-receipt.component';